export const SAGE100_OUTPUT_MAPPER_KEYS = {
    order: 'sage100.order',
    rfq: 'sage100.rfq',
} as const;

export const SAGE100_API_VERSIONS = ['5', '7', '9'];

export const AGENTIC_MIN_API_VERSION = 9;

export type Sage100TabType = 'configuration' | 'order' | 'rfq';

export const FORM_DEFAULT_VALUES = {
    name: '',
    entitlementId: '',
    dataSet: '',
    salesOrderType: '',
    offerDocumentType: 'VPA',
    authState: '',
    authFlow: 'client_credentials',
    orderChannelIds: [],
    rfqChannelIds: [],
    apiVersion: '',
    livePriceCheck: false,
    priceCheckBasis: 'unit_price',
    allowAgenticWrites: false,
    saveDocumentsAsDrafts: false,
    standardPriceList: '',
    ignoreExpiredOffers: true,
    useOutputMapping: false,
};

export type Sage100FormData = typeof FORM_DEFAULT_VALUES;
